import * as Web from '/js/lib/webact.js';

import * as PodcastSaver from '../../podcast-saver.js';
import { stringToElements } from '../../helpers.js';

import '../app-button/app-button.js';
import '../category-tags/category-tags.js';

class PodcastShowHeader extends Web.Component {
  constructor () {
    super(import.meta.url);
  }

  async updateButtonText () {
    const isSubscribed = await PodcastSaver.isSubscribed(this.getAttribute('podcast-rss'));

    if (isSubscribed) {
      this.subscribeButtonTextElement.setAttribute('key', 'unsubscribe');
    } else {
      this.subscribeButtonTextElement.setAttribute('key', 'subscribe');
    }
  }

  setImageDropShadow () {
    this.$('header').style.setProperty('--current-src', `url('${this.imageUrl}')`);
  }

  get imageUrl () {
    return this.$('slot[name="image"]').assignedNodes()[0].src;
  }

  updateDescription () {
    const descriptionDiv = this.$('.description');
    // textContent for server side rendered HTML entities, textContent for complete markup from SW.
    const slotContent = [...this.$('slot[name="description"]').assignedNodes()].map(node => node.innerHTML.indexOf('&lt;') !== -1 ? node.textContent : node.innerHTML).join('');

    descriptionDiv.innerHTML = null;

    descriptionDiv.appendChild(stringToElements(slotContent));

    for (let a of descriptionDiv.querySelectorAll('a')) {
      a.target = '_blank';
    }
  }

  async componentDidMount () {
    this.subscribeButtonTextElement = this.$('#subscribe-button i18n-text');

    this.updateButtonText();
    this.setImageDropShadow();
    this.updateDescription();

    this.$('#subscribe-button').addEventListener('click', async () => {
      const feed = {
        title: this.$('slot[name="title"]').assignedNodes()[0].innerHTML,
        imageUrl: this.imageUrl,
        slug: this.$('slot[name="slug"]').assignedNodes()[0].innerHTML,
        rssUrl: this.getAttribute('podcast-rss'),
        lastCheckDate: new Date('2020-09-09').getTime()
      };

      const isSubscribed = await PodcastSaver.isSubscribed(this.getAttribute('podcast-rss'));

      if (isSubscribed) {
        await PodcastSaver.unsubscribe(feed);
      } else {
        await PodcastSaver.subscribe(feed);
      }

      this.updateButtonText();
    });
  }
}

export default Web.registerComponent(PodcastShowHeader, {
  name: 'podcast-show-header'
});
